import i18n from "@/plugins/i18n";

export default function ({ globals }) {
	return {
		namespaced: true,
		state: {
			identifier: null,
			linkSent: false,
		},
		mutations: {
			SET_IDENTIFIER(state, value) {
				state.identifier = value ? value.replace(/\s/g, "") : value;
			},
			SET_LINK_SENT(state, value) {
				state.linkSent = value;
			},
		},
		actions: {
			async requestPasswordReset({ state, commit, dispatch }) {
				try {
					const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
					const response = await fetch(`${globalConfig.backends.users}/send-forgot-password`, {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							identifier: state.identifier,
						}),
					});

					const { error = null } = await response.json();

					if (error) throw new Error(error.code);

					this._vm.$chamaileon.pushToGtmDataLayer({
						event: "passwordReset",
						userEmail: state.identifier,
						timestamp: Math.floor(new Date().getTime() / 1000),
					});

					commit("SET_LINK_SENT", true);
				} catch (error) {
					const translationExists = i18n.te(`forgotPassword.submit.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";
					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`forgotPassword.submit.errorMessages.${code}`),
						target: {
							type: "flashToast",
							timeout: 4000,
						},
					}, { root: true });
					return;
				}
			},
		},
	};
}
